import { render, staticRenderFns } from "./IngresarPagoVirtualModal.vue?vue&type=template&id=84666310&scoped=true"
import script from "./IngresarPagoVirtualModal.vue?vue&type=script&lang=js"
export * from "./IngresarPagoVirtualModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84666310",
  null
  
)

export default component.exports